export default __webpack_public_path__ + "static/media/floor-13.52858ebd.jpg";